const tasks = [
  {
    label: 'Administratieve taken',
    key: 'administratievetaken',
  },
  {
    label: 'Analyseren',
    key: 'analyseren',
  },
  {
    label: 'Assisteren',
    key: 'assisteren',
  },
  {
    label: 'Conflicten oplossen',
    key: 'conflictenoplossen',
  },
  {
    label: 'Contact onderhouden',
    key: 'contactonderhouden',
  },
  {
    label: 'Creatief zijn',
    key: 'creatiefzijn',
  },
  {
    label: 'Cursussen/trainingen geven',
    key: 'cursussentraingengeven',
  },
  {
    label: 'Elektronische apparatuur repareren',
    key: 'elektronischeapparatierepareren',
  },
  {
    label: 'Fysiek inspannen',
    key: 'fysiekinspannen',
  },
  {
    label: 'Grote machines bedienen',
    key: 'grotemachinesbedienen',
  },
  {
    label: 'Informatie verzamelen',
    key: 'informatieverzamelen',
  },
  {
    label: 'Inroosteren',
    key: 'inroosteren',
  },
  {
    label: 'Klanten helpen',
    key: 'klantenhelpen',
  },
  {
    label: 'Leiding geven',
    key: 'leidinggeven',
  },
  {
    label: 'Lesgeven',
    key: 'lesgeven',
  },
  {
    label: 'Lezen',
    key: 'lezen',
  },
  {
    label: 'Machines repareren',
    key: 'machinesrepareren',
  },
  {
    label: 'Mensen adviseren',
    key: 'mensenadviseren',
  },
  {
    label: 'Mensen begeleiden',
    key: 'mensenbegeleiden',
  },
  {
    label: 'Mensen beinvloeden',
    key: 'mensenbeinvloeden',
  },
  {
    label: 'Mensen overtuigen',
    key: 'mensenovertuigen',
  },
  {
    label: "Met collega's overleggen",
    key: 'metcollegasoverleggen',
  },
]

export default tasks
